export enum LUMX_LISTS {
    /**
     * @value Movement cancelled. The item has returned to its starting position of %START_POSITION%
     * @description The use have cancelled the drag without changes.
     */
    DRAG_CANCELED = 'LUMX.DRAGGABLE.DRAG_CANCELED',
    /**
     * @value You have dropped the item. It has moved from position %START_POSITION% to %END_POSITION%.
     * @description The drag is ended, and the item has been moved.
     */
    DRAG_ENDED = 'LUMX.DRAGGABLE.DRAG_ENDED',
    /**
     * @value You have lifted an item in position %START_POSITION%.
     * @description The message announced when the user starts to drag an item
     */
    DRAG_STARTING = 'LUMX.DRAGGABLE.DRAG_STARTING',
    /**
     * @value You have moved the item from position %START_POSITION% to position %END_POSITION%.
     * @description The user have moved the dragged item to a new position.
     */
    DRAG_UPDATES = 'LUMX.DRAGGABLE.DRAG_UPDATES',
    /**
     * @value You have moved the item from position %START_ROW_POSITION% in row %START_ROW% to position %END_ROW_POSITION% in row %END_ROW%. %NEW_POSITION% over %TOTAL_ITEMS% items in the list.
     * @description The user have moved the dragged item to a new position.
     */
    DRAG_UPDATES_WITH_ROWS = 'LUMX.DRAGGABLE.DRAG_UPDATES_WITH_ROW',
    /**
     * @value To pick up a sortable item, press the space bar.
     * While sorting, use the arrow keys to move the item.
     * Press space again to drop the item in its new position, or press escape to cancel.
     * Some screen readers may require you to be in focus mode or to use your pass through key.
     */
    SORTABLE_SCREEN_READER_INSTRUCTIONS = 'LUMX_LISTS.SORTABLE_SCREEN_READER_INSTRUCTIONS',
}
